import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, GlobalSignalRListener, BaasicButton, BaasicConfirmModal, BaasicDropdown, ScrollToTopButton, BaasicDraggableModal, BaasicModal } from 'core/components'; //, GlobalSignalRListener, BaasicConfirmModalNew, ,  } from 'core/components';
import { PreviewLayout } from 'core/layouts';
import { ItemActionTriangle } from 'themes/components';
import { NikoFacilityOrderStatusBar, NikoFacilityOrderReasonForChangeModal, NikoFacilityOrderConfirmationModal, NikoFacilityOrderPatientTemplateNoteModal } from "application/niko-facility-order/components";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { DropDownButton, DropDownButtonItem, Button } from "@progress/kendo-react-buttons";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import moment from "moment";
import { observer } from "mobx-react";
import { NikoFacilityOrderUSIntakeClinicalInformationModal } from "application/niko-facility-order-us-intake/components";
import { NikoPatientInformationBar, NikoPatientInsuranceQuestionModal, NikoPatientInsuranceInfoNoteModal, NikoPatientEligibilityStatusNoteModal, NikoTemplateCreateModal, NikoTemplateMissingProductNoteModal, NikoTemplateInvoiceNoteModal, NikoPatientStatusModal, NikoPatientTemplateItemCalculationModal, NikoCreateNewPatientModal } from "application/niko-patient/components";
import { handleKeyDown, handlePaste, toDate } from "core/utils";
import { FacilityOrderTemplateNewFlowDeleteModal, FacilityOrderTemplateItemNewFlowDeleteQuestionModal } from "application/facility-order-new-flow/components"; //FacilityOrderTemplateItemNewFlowCalculationModal, ,
import { NikoFacilityOrderUSIntakeFindAndReplaceModal } from 'application/niko-facility-order-us-intake/components';
import { NikoFacilityOrderNewFlowExtraSuppliesAddModal } from "application/niko-facility-order-inventory/components";
// import { FacilityOrderTemplateNewFlowUSIntakePortalNoteModal } from "application/facility-order-new-flow-us-intake/components"; //FacilityOrderPatientNewFlowUSIntakePreview, FacilityOrderNewFlowStatusBar, FacilityOrderNewFlowUSIntakeFindAndReplaceModal, CreateFacilityOrderTemplateUSIntakeNewFlowModal, FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal, FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal, ,FacilityOrderTemplateDoNotSupplyModal, FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModal, FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal, FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal, FacilityOrderPatientNewFlowInsuranceEditModal
// import { FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal, FacilityOrderPatientNewFlowInsuranceNoteModal } from "application/facility-order-new-flow-insurance/components";
// import { FacilityOrderTemplateNewFlowInvoiceNoteModal } from "application/facility-order/components";
function NikoFacilityOrderUSIntakePreviewTemplate({ nikoFacilityOrderUSIntakePreviewViewStore }) {
  const {
    loaderStore,
    refreshKey,
    goToFacilityPreview,
    goToFacilityCalendar,
    tabItems,
    selectedStatusAbrv,
    setStatus,
    startUSIntakeStatus,
    disabledByStatus,
    disabledBySendOrder,
    filterByQuestion,
    filterByCategory,
    questionsStore,
    selectedQuestions,
    itemCategoryStore,
    itemCategories,
    fetchingData,
    disabled,
    statusConfirmModal,
    usIntakeStatus,
    nikoPatientDetails,
    reviewAllPatientTemplates,
    isReviewed,
    // isEmpty,//ni
    hasValidEmailType,//ni
    isInventoryRequestSent,//ni
    hideInventoryEmailButton,//ni
    openInventoryRequestWindow,//ni
    setUSIntakeStatusComplete,
    nikoPatientInsuranceQuestionModal,
    nikoPatientInsuranceInfoNoteModal,
    nikoPatientEligibilityStatusNoteModal,
    nikoTemplateCreateModal,
    nikoTemplateMissingProductNoteModal,
    nikoTemplateInvoiceNoteModal,
    patientTemplateDoNotSupplyModal,
    patientTemplateDiscontinuedModal,
    nikoPatientStatusModal,
    patientTemplateDeleteModal,
    nikoPatientTemplateItemCalculationModal,
    nikoFacilityOrderUSIntakeClinicalInformationModal,
    nikoFacilityOrderReasonForChangeModal,
    nikoPatientTemplateItemNewFlowDeleteQuestionModal,
    orderHistory,
    patientTemplateNoteModal,
    templateChangeConfirmModal,
    rootStore,
    id,
    signalRAction,
    // changeStatusId,
    // pickTicketHeaderStatus,
    // facilityOrder,
    // facilityOrderStatus,
    // isStatusBarVisible,
    // changeStatusBarVisibility,
    // goToCreatePatient,
    downloadInventoryReport,
    facilityOrder,
    openNikoFacilityOrderUSIntakeFindAndReplaceModal,
    nikoFacilityOrderUSIntakeFindAndReplaceModal,
    nikoFacilityOrderNewFlowExtraSuppliesAddModal,
    // downloadFacilityOrderCsv,
    // facilityOrderTemplatesGroupByPatient,
    // lookups,
    // createFacilityOrderTemplateUSIntakeNewFlowModal,
    // facilityOrderTemplateItemNewFlowCalculationModal,
    // facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal,
    // facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal,
    // facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal,
    // facilityOrderTemplateNewFlowInvoiceNoteModal,
    // facilityOrderTemplateDoNotSupplyModal,
    // facilityOrderTemplateNewFlowUSIntakeClinicalInformationModal,
    // ,
    // facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal,
    // facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal,
    // facilityOrderPatientNewFlowInsuranceEditModal,
    // facilityOrderPatientNewFlowInsuranceNoteModal,
    // extraSuppliesApprovalRequiredModal,
    isInventoryStepAllowed,
    openInventoryRequestWindowThroughActionsMenu,
    nikoCreateNewPatientModal,
    openCreateNewPatientModal,
  } = nikoFacilityOrderUSIntakePreviewViewStore;

  const handleActionDropDownItemsOnClick = (e) => {
    if (e.item.text === "New Patient") {
      openCreateNewPatientModal();
    }
    if (e.item.text === "Find and Replace") {
      openNikoFacilityOrderUSIntakeFindAndReplaceModal();
    }
    if (e.item.text === "Inventory Report") {
      downloadInventoryReport();
    }
    // if (e.item.text === "Export FO CSV") {
    //     downloadFacilityOrderCsv();
    // }
    if (e.item.text === "Inventory Request Email") {
      openInventoryRequestWindowThroughActionsMenu();
    }
  }

  return (
    <PreviewLayout className="container container--new-flow" store={nikoFacilityOrderUSIntakePreviewViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading}>
      <ReactTooltip positionStrategy="fixed" id="usIntakeTooltip" place="bottom" />
      {<GlobalSignalRListener groupId={id} rootStore={rootStore} action={signalRAction} />/*
            {!loaderStore.loading &&
                <React.Fragment>
                    {(pickTicketHeaderStatus == "in-progress" || pickTicketHeaderStatus == "completed" || facilityOrder.sendOrder) &&
                        <div className='purches-notification'>
                            <div className='message__bar purches-notification-row'>
                                <span>{pickTicketHeaderStatus === "in-progress" ? "Purchasing is in progress. Don't make changes to the facility order." : pickTicketHeaderStatus === "completed" ? "Purchasing is complete. Don't make changes to the facility order." : "Billing is in Progress, any changes made must be reported to the biller."}</span>
                            </div>
                        </div>
                    }*/}
      {facilityOrder && facilityOrder.facility && <NikoFacilityOrderStatusBar key={refreshKey} title={`${facilityOrder.facility.name} - DOS ${toDate(facilityOrder.dateOfService)}`} pageViewStore={nikoFacilityOrderUSIntakePreviewViewStore} isInventoryStepAllowed={isInventoryStepAllowed}>
        <div className="content__header__actions card--tertiary__data__item">
          <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Facility Order History" data-tooltip-id="usIntakeTooltip" onClick={() => orderHistory()}><i className="u-icon u-icon--med-lrg u-icon--us-history"></i></a>
          <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Facility Preview" data-tooltip-id="usIntakeTooltip" onClick={() => goToFacilityPreview()}><i className="u-icon u-icon--sml u-icon--preview--dark"></i></a>
          <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Ordering Calendar" data-tooltip-id="usIntakeTooltip" onClick={() => goToFacilityCalendar()}><i className="u-icon u-icon--sml u-icon--schedules"></i></a>
        </div>
      </NikoFacilityOrderStatusBar>}
      <div className="u-flex--space-between">
        <div className="tabs__wrapper">
          <div className="tabs tabs--fullwidth">
            {tabItems.map(item =>
              <BaasicButton key={item.abrv}
                className={"tabs__item " + (item.abrv == selectedStatusAbrv ? 'active' : '')}
                label={item.name}
                onClick={() => item.abrv != selectedStatusAbrv ? setStatus(item.abrv) : {}}
              />
            )}
          </div>
        </div>
        <div className="u-flex--default u-mar--left--auto">
          {disabledByStatus &&
            <BaasicButton className="btn btn--base btn--primary u-mar--right--sml" disabled={disabledBySendOrder || disabled} label="Start" onClick={() => startUSIntakeStatus()} />
          }
          {selectedStatusAbrv !== "discharge" &&
            <div className="multiselect__group is-questions u-mar--right--sml">
              <MultiSelect
                data={questionsStore.originalItems}
                textField="name"
                dataItemKey="id"
                value={selectedQuestions.slice()}
                filterable={false}
                placeholder="Please select"
                onChange={(e) => filterByQuestion(e)}
                tags={
                  selectedQuestions.length > 0
                    ? [
                      {
                        text: selectedQuestions.length == 1 ? selectedQuestions[0].name : `Multiple`,
                        data: selectedQuestions.slice(),
                      },
                    ] : []
                }
              />
            </div>
          }
          <div className="multiselect__group is-category u-mar--right--sml">
            <MultiSelect
              data={itemCategoryStore.originalItems}
              textField="name"
              dataItemKey="id"
              value={itemCategories.slice()}
              filterable={false}
              placeholder="Please select"
              onChange={(e) => filterByCategory(e)}
              tags={
                itemCategories.length > 0
                  ? [
                    {
                      text: itemCategories.length == 1 ? itemCategories[0].name : `Multiple`,
                      data: itemCategories.slice(),
                    },
                  ] : []
              }
            />
          </div>
          {selectedStatusAbrv === "discharge" &&
            <BaasicButton className="btn btn--base btn--sml btn--primary u-mar--right--sml" icon="u-icon u-icon--xmed u-icon--checks" label="Review All" showTooltip={false} onClick={() => { reviewAllPatientTemplates() }} disabled={disabledByStatus || disabledBySendOrder || disabled || !(nikoPatientDetails.length > 0 && nikoPatientDetails.some(np => np.patientTemplates && !np.patientTemplates.some(pt => pt.isUsIntakeReviewed)))} /> //&& !((np.isNew || np.insuranceStatusId === changeStatusId) && !np.isInsuranceReviewed)
          }
          <div className='u-mar--right--sml'>
            <DropDownButton
              fillMode={"solid"}
              themeColor={"primary"}
              text="Actions"
              onItemClick={(e) => handleActionDropDownItemsOnClick(e)}
              buttonClass="btn btn--base btn--sml btn--ghost"
              disabled={disabledByStatus}
              popupSettings={{
                popupClass: "is-clean",
                animate: false,
                anchorAlign: { horizontal: "right", vertical: "bottom" },
                popupAlign: { horizontal: "right", vertical: "top" }
              }}
            >
              <DropDownButtonItem text="New Patient" iconClass="u-icon u-icon--sml u-icon--add-lined u-mar--right--tny" />
              <DropDownButtonItem text="Inventory Report" />
              <DropDownButtonItem text="Inventory Request Email" />
              {!disabledBySendOrder && <DropDownButtonItem text="Find and Replace" />}
              {/* <DropDownButtonItem text="Export FO CSV" /> */}
            </DropDownButton>
          </div>
        </div>
      </div>
      {fetchingData ?
        <div>Loading...</div>
        :
        <React.Fragment>
          {selectedStatusAbrv === "in-progress" && usIntakeStatus && usIntakeStatus.completedOn &&
            <div className='u-mar--bottom--tny'>
              <div className="u-mar--bottom--sml">US Intake review has been completed on {moment(usIntakeStatus.completedOn).format("MM/DD/YYYY, hh:mm A")}</div>
            </div>
          }
          {selectedStatusAbrv === "discharge" && !(usIntakeStatus && usIntakeStatus.completedOn) && isReviewed &&
            (isInventoryRequestSent || hideInventoryEmailButton) &&
            <div className="empty-state--facility-orders-discharges">
              <p className="empty-state--facility-orders-discharges--description">You have no orders in progress!</p>
              <BaasicButton className="btn btn--base btn--primary" disabled={disabledBySendOrder} label="US Intake is Complete" onClick={() => setUSIntakeStatusComplete()} />
            </div>
          }
          {selectedStatusAbrv === "discharge" && !(usIntakeStatus && usIntakeStatus.completedOn) && isReviewed && !isInventoryRequestSent && !hideInventoryEmailButton && hasValidEmailType &&
            <div className="empty-state--facility-orders-discharges">
              <p className="empty-state--facility-orders-discharges--description">You have no orders in progress!</p>
              <BaasicButton className="btn btn--base btn--primary" disabled={disabledBySendOrder} icon="u-icon u-icon--med u-icon--mail-send--new--invert" label="Inventory Request" onClick={() => openInventoryRequestWindow()} />
            </div>
          }
          {(nikoPatientDetails && nikoPatientDetails.length > 0) ?
            nikoPatientDetails.map(nikoPatientDetail => {
              return (
                <NikoPatientTemplate
                  key={nikoPatientDetail.id}
                  nikoFacilityOrderUSIntakePreviewViewStore={nikoFacilityOrderUSIntakePreviewViewStore}
                  nikoPatientDetail={nikoPatientDetail}
                />
              );
            })
            :
            !(usIntakeStatus && usIntakeStatus.completedOn) && selectedStatusAbrv === "in-progress" &&
            <React.Fragment>
              {isReviewed && !isInventoryRequestSent && !hideInventoryEmailButton && hasValidEmailType &&
                (
                  <div className="empty-state--facility-orders">
                    <div className="empty-state--facility-orders--table"></div>
                    <p className="empty-state--facility-orders--description">You have no orders in progress!</p>
                    <BaasicButton className="btn btn--base btn--primary" disabled={disabledBySendOrder} icon="u-icon u-icon--med u-icon--mail-send--new--invert" label="Inventory Request" onClick={() => openInventoryRequestWindow()} />
                  </div>)
              }
              {isReviewed &&
                (isInventoryRequestSent || hideInventoryEmailButton) &&
                <div className="empty-state--facility-orders">
                  <div className="empty-state--facility-orders--table"></div>
                  <p className="empty-state--facility-orders--description">You have no orders in progress!</p>
                  <BaasicButton
                    className="btn btn--base btn--primary"
                    label="US Intake is Complete"
                    onClick={() => setUSIntakeStatusComplete()}
                  />
                </div>
              }
              {isReviewed === false && itemCategories.length == 0 && selectedQuestions.length == 0 &&
                !isInventoryRequestSent &&
                <div className="u-mar--bottom--sml">
                  All In Progress templates have been reviewed. Please review the discharged templates to complete US Intake.
                </div>
              }
            </React.Fragment>
          }
        </React.Fragment>
      }
      <BaasicConfirmModal modalParams={statusConfirmModal} />
      < BaasicDraggableModal modalParams={nikoPatientInsuranceQuestionModal} className="modal__content modal--med" >
        <NikoPatientInsuranceQuestionModal />
      </BaasicDraggableModal >
      <BaasicDraggableModal modalParams={nikoPatientInsuranceInfoNoteModal} className="modal__content modal--med">
        <NikoPatientInsuranceInfoNoteModal />
      </BaasicDraggableModal>
      <BaasicModal modalParams={nikoPatientEligibilityStatusNoteModal} className="modal__content modal--med" >
        <NikoPatientEligibilityStatusNoteModal />
      </BaasicModal >
      <BaasicModal modalParams={nikoTemplateCreateModal} className="modal__content modal--xxlrg">
        <NikoTemplateCreateModal />
      </BaasicModal>
      <BaasicDraggableModal modalParams={nikoTemplateMissingProductNoteModal} className="modal__content modal--med">
        <NikoTemplateMissingProductNoteModal />
      </BaasicDraggableModal>
      <BaasicDraggableModal modalParams={nikoTemplateInvoiceNoteModal} className="modal__content modal--med">
        <NikoTemplateInvoiceNoteModal />
      </BaasicDraggableModal>
      <BaasicDraggableModal modalParams={patientTemplateDoNotSupplyModal} className="modal__content modal--med">
        <NikoFacilityOrderConfirmationModal />
      </BaasicDraggableModal>
      <BaasicDraggableModal modalParams={patientTemplateDiscontinuedModal} className="modal__content modal--med">
        <NikoFacilityOrderConfirmationModal />
      </BaasicDraggableModal>
      <BaasicModal modalParams={nikoPatientStatusModal} className="modal__content modal--med">
        <NikoPatientStatusModal />
      </BaasicModal>
      <BaasicModal modalParams={patientTemplateDeleteModal} className="modal__content modal--med">
        <FacilityOrderTemplateNewFlowDeleteModal />
      </BaasicModal>
      <BaasicDraggableModal modalParams={nikoPatientTemplateItemCalculationModal} className="modal__content modal--lrg">
        <NikoPatientTemplateItemCalculationModal />
      </BaasicDraggableModal>
      <BaasicDraggableModal modalParams={nikoFacilityOrderUSIntakeClinicalInformationModal} className="modal__content modal--lrg">
        <NikoFacilityOrderUSIntakeClinicalInformationModal />
      </BaasicDraggableModal>
      <BaasicModal modalParams={nikoFacilityOrderReasonForChangeModal} className="modal__content modal--lrg">
        <NikoFacilityOrderReasonForChangeModal />
      </BaasicModal>
      <BaasicModal modalParams={nikoPatientTemplateItemNewFlowDeleteQuestionModal} className="modal__content modal--med">
        <FacilityOrderTemplateItemNewFlowDeleteQuestionModal />
      </BaasicModal>
      <BaasicDraggableModal modalParams={patientTemplateNoteModal} className="modal__content modal--med">
        <NikoFacilityOrderPatientTemplateNoteModal />
      </BaasicDraggableModal>
      <BaasicConfirmModal modalParams={templateChangeConfirmModal} />
      <BaasicModal modalParams={nikoFacilityOrderUSIntakeFindAndReplaceModal} className="modal__content modal--xlrg">
        <NikoFacilityOrderUSIntakeFindAndReplaceModal />
      </BaasicModal>
      <BaasicModal modalParams={nikoFacilityOrderNewFlowExtraSuppliesAddModal} className="modal__content modal--xxlrg">
        <NikoFacilityOrderNewFlowExtraSuppliesAddModal />
      </BaasicModal>
      {/*
            <BaasicModal modalParams={createFacilityOrderTemplateUSIntakeNewFlowModal} className="modal__content modal--xxlrg">
                <CreateFacilityOrderTemplateUSIntakeNewFlowModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateItemNewFlowCalculationModal}>
                <FacilityOrderTemplateItemNewFlowCalculationModal />
            </BaasicDraggableModal>
            <BaasicDraggableModal modalParams={facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal />
            </BaasicDraggableModal>
            <BaasicModal modalParams={facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal} className="modal__content modal--xxlrg">
                <FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderTemplateNewFlowInvoiceNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowInvoiceNoteModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal />
            </BaasicDraggableModal>
            <BaasicDraggableModal modalParams={facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal />
            </BaasicDraggableModal>
            <BaasicModal modalParams={facilityOrderPatientNewFlowInsuranceEditModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowInsuranceEditModal />
            </BaasicModal>
            <BaasicConfirmModalNew modalParams={extraSuppliesApprovalRequiredModal} />*/}
      <BaasicModal modalParams={nikoCreateNewPatientModal} className="modal__content modal--xxlrg">
        <NikoCreateNewPatientModal />
      </BaasicModal>
      <ScrollToTopButton />
    </PreviewLayout>
  )
}

NikoFacilityOrderUSIntakePreviewTemplate.propTypes = {
  nikoFacilityOrderUSIntakePreviewViewStore: PropTypes.object.isRequired
};

const NikoPatientTemplate = observer(({ nikoFacilityOrderUSIntakePreviewViewStore, nikoPatientDetail }) => {
  const {
    selectedStatusAbrv,
    disabledByStatus,
    disabledBySendOrder,
    disabled,
    statuses,
    statusStore,
    inProgressStatusId,
    changeStatusId,
    noChangeStatusId,
    openNikoPatientInsuranceQuestionModal,
    openNikoPatientInsuranceInfoNoteModal,
    openNikoHealthPatient,
    updateNikoPatientInsuranceInfoNote,
    openNikoPatientEligibilityStatusNoteModal,
    openNikoTemplateCreateModal,
    openNikoPatientStatusModal,
    openReasonForChangeModal,
    reviewPatientTemplates,
    reviewNikoPatient,
    showPreviousFlag,
    getFieldHistory,
    fetchInsuranceChangeHistory,
    insuranceChangeHistoryMap,
    showInsuranceChangeHistory
    // hospitalClassName,
    // dischargedClassName,
    // expiredClassName,
    // activeClassName,
    // disabledPatient,
    // patient,
    // isQtyChange,
    // facilityOrder,
    // facilityOrderPatient,
    // facilityOrderTemplates,
    // isMasterPatient,
    // pageViewStore,
    // inactiveOptions,
    // inactiveOptionStore,
    // setInsuranceStatus,
    // openFacilityOrderPatientNewFlowInsuranceEditModal,
    // openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal,
    // getSelectedInactiveOption,
    // updateFacilityOrderPatient,
    // patientNote,
    // oldTemplate
  } = nikoFacilityOrderUSIntakePreviewViewStore;

  var ichVisible = showInsuranceChangeHistory === nikoPatientDetail.id;
  var ich = ichVisible ? (insuranceChangeHistoryMap[nikoPatientDetail.id] || {}) : {};

  var renderChangeHistory = function (fieldKey) {
    var entry = ich[fieldKey];
    if (!entry || !entry.userName) return null;
    var d = new Date(entry.eventDate + "Z");
    var fd = d.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '');
    return <div className="card--info__wrap"><span className="card--info">{entry.userName}, {fd}</span></div>;
  };

  // const handleDropDownInsuranceItemsOnClick = async (e) => {
  //     if (e.item.text === "No changes") {
  //         setInsuranceStatus("no-change")
  //     }
  //     else if (e.item.text === "Change/Review") {
  //         setInsuranceStatus("change", true)
  //     }
  // }

  const TooltipContent = observer(({ initialValue, history, fieldName }) => {
    if (!history || history.fieldName !== fieldName) return null;

    const date = new Date(history.eventDate + "Z");
    const formattedDate = date.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');

    if (fieldName === 'ImportAction') {
      return (<div>
        <div>{history.action} by {history.userName}</div>
        <div style={{ fontSize: '11px', opacity: 0.75 }}>{formattedDate}</div>
      </div>);
    }
    return (<div>
      <div>Previous: {initialValue ? initialValue : 'blank'}</div>
      <div style={{ fontSize: '11px', opacity: 0.75 }}>
        {history ? history.userName + ', ' + formattedDate : '—'}
      </div>
    </div>)
  });

  return (
    <React.Fragment>
      <ReactTooltip positionStrategy="fixed" id={"nikoPatientTooltip" + nikoPatientDetail.id} place="bottom" />
      <ReactTooltip positionStrategy="fixed" id={"registerPatientTopTip" + nikoPatientDetail.id} place="top" delayShow={650} render={() =>
        <TooltipContent initialValue={nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.Status} delayShow={650} history={nikoPatientDetail.history} fieldName={'Status'} />}>
      </ReactTooltip>
      <div className="card--tertiary u-mar--bottom--sml--alt">
        <div className={`card--tertiary__header is-niko ${selectedStatusAbrv === "discharge" ? "" : "card--tertiary__header--insurance"}`}>
          <div className="u-flex--default">
            <h4 className="card--tertiary__header__title">
              {nikoPatientDetail.nikoPatient.lastName && `${nikoPatientDetail.nikoPatient.lastName}`}
              {nikoPatientDetail.nikoPatient.lastName && nikoPatientDetail.nikoPatient.firstName && ', '}
              {nikoPatientDetail.nikoPatient.firstName && `${nikoPatientDetail.nikoPatient.firstName}`}
            </h4>
            <NikoPatientInformationBar nikoPatient={nikoPatientDetail.nikoPatient} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} showVisibilityOption={true} />
          </div>
          {
            nikoPatientDetail.isNew && selectedStatusAbrv === "discharge" &&
            <div className="status status--sml status--success">
              <p>New Patient</p>
            </div>
          }
          <div className="u-flex--default u-align--h--right">
            <BaasicButton
              className="btn btn--icon--sml-med btn--light is-plus u-mar--right--xsml"
              icon="u-icon u-icon--xmed u-icon--add-lined"
              label="Add Template"
              onlyIcon={true}
              onClick={() => { openNikoTemplateCreateModal(nikoPatientDetail) }}//isMasterPatient
              disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
            />
            {
              nikoPatientDetail.patientTemplates.some(x => !x.isInitialIntakeReviewed) ?
                <div className="segmented-control u-mar--left--xsml">
                  <Button key={statuses[0].id} className={nikoPatientDetail.hospitalClassName} onClick={() => openNikoPatientStatusModal(nikoPatientDetail, statuses[0].id)} disabled={disabledByStatus || disabledBySendOrder || disabled || (nikoPatientDetail.disabled && !(selectedStatusAbrv == "in-progress" && nikoPatientDetail.status === 'Hospital'))}>{statuses[0].id}
                    {nikoPatientDetail.status === "Hospital" && showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew && <div className="previous-status-opacity-75" data-tooltip-id={"registerPatientTopTip" + nikoPatientDetail.id} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Status', nikoPatientDetail.status)} data-tooltip-content="" ></div>}
                  </Button>
                  <Button key={statuses[1].id} className={nikoPatientDetail.dischargedClassName} onClick={() => openNikoPatientStatusModal(nikoPatientDetail, statuses[1].id)} disabled={disabledByStatus || disabledBySendOrder || disabled || (nikoPatientDetail.disabled && !(selectedStatusAbrv == "in-progress" && nikoPatientDetail.status === 'Hospital'))}>{statuses[1].id}
                    {nikoPatientDetail.status === "Discharged" && showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew && <div className="previous-status-opacity-75" data-tooltip-id={"registerPatientTopTip" + nikoPatientDetail.id} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Status', nikoPatientDetail.status)} data-tooltip-content="" ></div>}
                  </Button>
                  <Button key={statuses[2].id} className={nikoPatientDetail.expiredClassName} onClick={() => openNikoPatientStatusModal(nikoPatientDetail, statuses[2].id)} disabled={disabledByStatus || disabledBySendOrder || disabled || (nikoPatientDetail.disabled && !(selectedStatusAbrv == "in-progress" && nikoPatientDetail.status === 'Hospital'))}>{statuses[2].id}
                    {nikoPatientDetail.status === "Expired" && showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew && <div className="previous-status-opacity-75" data-tooltip-id={"registerPatientTopTip" + nikoPatientDetail.id} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Status', nikoPatientDetail.status)} data-tooltip-content="" ></div>}
                  </Button>
                  <Button key={statuses[3].id} className={nikoPatientDetail.activeClassName} onClick={() => nikoPatientDetail.status != statuses[3].id ? openNikoPatientStatusModal(nikoPatientDetail, statuses[3].id) : {}} disabled={disabledByStatus || disabledBySendOrder || disabled || (nikoPatientDetail.disabled && !(selectedStatusAbrv == "in-progress" && nikoPatientDetail.status === 'Hospital'))}>{statuses[3].id}
                    {nikoPatientDetail.status === "Active" && showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew && <div className="previous-status-opacity-75" data-tooltip-id={"registerPatientTopTip" + nikoPatientDetail.id} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Status', nikoPatientDetail.status)} data-tooltip-content="" ></div>}
                  </Button>
                </div>
                :
                <div className={`${showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew ? "k-dropdown--status-indicator-opacity-50" : ""} w--200--px u-align--h--right u-mar--left--xsml`} >
                  <BaasicDropdown store={statusStore} value={nikoPatientDetail.status} onChange={(e) => { openNikoPatientStatusModal(nikoPatientDetail, e.value.id) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} />
                  <div className="k-dropdown--tooltip" data-tooltip-id={showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew ? "registerPatientTopTip" + nikoPatientDetail.id : ""} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Status', nikoPatientDetail.status)} data-tooltip-content="" ></div>
                </div>
            }
            {selectedStatusAbrv === "in-progress" &&
              <BaasicButton
                className="btn btn--base btn--primary u-mar--left--xsml"
                icon="u-icon u-icon--med u-icon--check-list"
                label="Review All"
                showTooltip={false}
                onlyIcon={false}
                onClick={() => { reviewPatientTemplates(nikoPatientDetail, null, true) }}
                disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled ||
                  (
                    nikoPatientDetail.insuranceStatusId === inProgressStatusId
                    ||
                    (
                      (nikoPatientDetail.isNew || nikoPatientDetail.insuranceStatusId === changeStatusId)
                      &&
                      !(nikoPatientDetail.isInsuranceReviewed && nikoPatientDetail.patientTemplates.every(x => x.intakeStatusId === noChangeStatusId))
                    )
                    ||
                    (nikoPatientDetail.insuranceStatusId === noChangeStatusId && !nikoPatientDetail.patientTemplates.every(x => x.intakeStatusId === noChangeStatusId))
                  )
                }
              />
            }
            {selectedStatusAbrv === "discharge" &&
              <BaasicButton
                className="btn btn--base btn--primary u-mar--left--xsml"
                icon="u-icon u-icon--med u-icon--check-list"
                label="Review"
                showTooltip={false}
                onlyIcon={false}
                onClick={() => { reviewPatientTemplates(nikoPatientDetail, null, true) }}
                disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled ||
                  nikoPatientDetail.patientTemplates.every(i => i.isUsIntakeReviewed)
                  // || ((nikoPatientDetail.isNew || nikoPatientDetail.insuranceStatusId === changeStatusId) && !nikoPatientDetail.isInsuranceReviewed)
                } />
            }
          </div>
        </div>
        <React.Fragment>
          {selectedStatusAbrv !== "discharge" &&
            <div className='niko__status__wrapper u-mar--right--status-low'>
              {nikoPatientDetail.isNew ?
                <div className={` ${disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled ? "is-disabled" : ""}`}>
                  <div className="niko__status yellow no-bg">
                    <div className="niko__status__holder">
                      <Button className="niko__status__btn" icon="u-icon u-icon--xsml u-icon--persons--yellow" disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}>NEW PATIENT</Button>
                    </div>
                  </div>
                </div>
                :
                nikoPatientDetail.insuranceStatusId === inProgressStatusId ?
                  <div className="niko__status grey">
                    <div className={`niko__status__holder not-assigned`}>
                      <Button icon="u-icon u-icon--xxsml u-icon--info-fill u-mar--y--sml" className="niko__status__btn" > NOT ASSIGNED </Button>
                    </div>
                  </div>
                  :
                  <div className={`${disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled ? "is-disabled" : ""}`}>
                    <div className={`niko__status yellow ${nikoPatientDetail.insuranceStatusId === noChangeStatusId ? "success" : "warning"}`}>
                      <div className="niko__status__holder">
                        <Button className={`niko__status__btn ${nikoPatientDetail.insuranceStatusId === noChangeStatusId ? "success" : "warning"}`}> {nikoPatientDetail.insuranceStatusId === noChangeStatusId ? "NO CHANGES" : "CHANGES"} </Button>
                      </div>
                    </div>
                  </div>
              }
            </div>
          }
          <div className="card--tertiary__subheader btn--group__wrapper is-niko">
            <div className="card--tertiary__flex">
              <div className="status--sqare__wrapper u-mar--left--xsml">
                <BaasicButton
                  // type='button'
                  className="btn btn--base-plus btn--light btn--uppercase  no-click"
                  label={nikoPatientDetail.eligibilityStatus ? nikoPatientDetail.eligibilityStatus.name : "Blank"}
                  disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                // onClick={() => { openReasonForChangeModal(nikoPatient) }}
                />
                {nikoPatientDetail.eligibilityStatus && nikoPatientDetail.eligibilityStatus.name != "Eligible" &&
                  <React.Fragment>
                    <ReactTooltip positionStrategy="fixed" id={"patientTemplateEligibilityStatusNoteTooltip" + nikoPatientDetail.id} place="bottom" />
                    <Button className="btn btn--link u-mar--left--tny" icon="u-icon u-icon--med u-icon--us-note" onClick={() => openNikoPatientEligibilityStatusNoteModal(nikoPatientDetail)} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Eligibility Status Note" data-tooltip-id={"patientTemplateEligibilityStatusNoteTooltip" + nikoPatientDetail.id} />
                  </React.Fragment>
                }
              </div>
              <div className="card--tertiary__data">
                <div>
                  <div className="card--tertiary__data__item">
                    <div>Primary:</div>
                    <div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.primaryActive.insurance.current && nikoPatientDetail.primaryActive.insurance.current.name}</div>
                    {nikoPatientDetail.primaryActive.policyNo.current && <div>{nikoPatientDetail.primaryActive.policyNo.current}</div>}
                  </div>
                  {nikoPatientDetail.primaryInactive.insurance.current &&
                    <div className="card--tertiary__data__item">
                      <div>Inactive:</div>
                      <div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.primaryInactive.insurance.current.name}</div>
                      <div>{nikoPatientDetail.primaryInactive.policyNo.current && nikoPatientDetail.primaryInactive.policyNo.current}</div>
                    </div>
                  }
                </div>
                <div>
                  <div className="card--tertiary__data__item">
                    <div>Secondary:</div>
                    <div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.secondaryActive.insurance.current && nikoPatientDetail.secondaryActive.insurance.current.name}</div>
                    {nikoPatientDetail.secondaryActive.policyNo.current && <div>{nikoPatientDetail.secondaryActive.policyNo.current}</div>}
                  </div>
                  {nikoPatientDetail.secondaryInactive.insurance.current &&
                    <div className="card--tertiary__data__item">
                      <div>Inactive:</div>
                      <div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.secondaryInactive.insurance.current.name}</div>
                      <div>{nikoPatientDetail.secondaryInactive.policyNo.current && nikoPatientDetail.secondaryInactive.policyNo.current}</div>
                    </div>
                  }
                </div>
              </div>
              {
                nikoPatientDetail.insuranceQuestion &&
                <div className="u-flex u-flex--default u-flex--gap--2">
                  <div className="card--tertiary__header__divider"></div>
                  <Button className="btn btn--status--red u-mar--left--xsml" icon="u-icon u-icon--med-lrg u-icon--us-question-note--red" onClick={() => { openNikoPatientInsuranceQuestionModal(nikoPatientDetail) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} />
                </div>
              }
              <div className="u-flex u-flex--default u-align--h--right">
                <div className="btn--group">
                  <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-insurance-external-link" onClick={() => openNikoHealthPatient(nikoPatientDetail.nikoPatient.remoteId)} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Niko" data-tooltip-id={"nikoPatientTooltip" + nikoPatientDetail.id} />
                  {!nikoPatientDetail.insuranceQuestion &&
                    <React.Fragment>
                      <ReactTooltip positionStrategy="fixed" id={"nikoPatientInsuranceQuestionTooltip" + nikoPatientDetail.id} place="bottom" />
                      <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-question-note-sh" onClick={() => openNikoPatientInsuranceQuestionModal(nikoPatientDetail)} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Insurance Question" data-tooltip-id={"nikoPatientInsuranceQuestionTooltip" + nikoPatientDetail.id} />
                    </React.Fragment>
                  }
                  <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-note" onClick={() => openNikoPatientInsuranceInfoNoteModal(nikoPatientDetail)} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Insurance Info Note" data-tooltip-id={"nikoPatientTooltip" + nikoPatientDetail.id} />
                  <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-edit" onClick={() => { openReasonForChangeModal(nikoPatientDetail) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Edit Insurances" data-tooltip-id={"nikoPatientTooltip" + nikoPatientDetail.id} />
                  {/* <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-history" onClick={() => openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal()} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Change History" data-tooltip-id={"registerPatientBottomTip" + nikoPatientDetail.id} /> */}
                  <div className="btn--group__divider"></div>
                </div>

                {nikoPatientDetail.patientTemplates.some(fot => fot.isPriorAuthNeeded) &&
                  <BaasicButton
                    type='button'
                    className="btn btn--base-plus btn--light is-grey no-click u-mar--right--tny"
                    label={`PAR ${nikoPatientDetail.patientTemplates.filter(fot => fot.isPriorAuthNeeded).length}/${nikoPatientDetail.patientTemplates.length}`}
                    disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                  />
                }
                <div className="status--sqare__wrapper" data-tooltip-content={!nikoPatientDetail.eligibilityStatusId ? "Eligibility Status must be selected" : ""} data-tooltip-id={!nikoPatientDetail.eligibilityStatusId ? `nikoPatientTooltip${nikoPatientDetail.id}` : ""}>
                  {
                    selectedStatusAbrv === "in-progress" && (nikoPatientDetail.isNew || nikoPatientDetail.insuranceStatusId === changeStatusId) &&
                    <Button className="btn btn--icon btn--icon--sml-med btn--primary u-mar--left--xsml" icon={`${nikoPatientDetail.isInsuranceReviewed ? "u-icon u-icon--med u-icon--unreview" : "u-icon u-icon--med u-icon--us-question-note-sh--light"}`} onClick={() => reviewNikoPatient(nikoPatientDetail)} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled || !nikoPatientDetail.eligibilityStatusId} data-tooltip-content={`${nikoPatientDetail.isInsuranceReviewed ? "Unreview Insurance" : "Review Insurance"}`} data-tooltip-id={"nikoPatientTooltip" + nikoPatientDetail.id} />
                  }
                </div>
              </div>
            </div>
            <div>
              {nikoPatientDetail.insuranceInfoNote &&
                <div className="c-message has-input c-message--note u-mar--top--sml">
                  <i className="u-icon u-icon--sml u-icon--add-note" />
                  <input
                    className="input input--sml input--message u-flex--grow--1 type--sml"
                    onClick={(e) => e.target.select()}
                    onChange={(e) => { updateNikoPatientInsuranceInfoNote(nikoPatientDetail, e.target.value) }}
                    onBlur={(e) => { updateNikoPatientInsuranceInfoNote(nikoPatientDetail, e.target.value, true) }}
                    value={nikoPatientDetail.tempInsuranceInfoNote}
                    disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                  />
                </div>
              }
              {((!nikoPatientDetail.isInsuranceReviewed && selectedStatusAbrv !== "intake-reviewed" && nikoPatientDetail.note) || nikoPatientDetail.hasHistory) &&
                <div className={`u-mar--top--lrg c-message has-dom-badge ${!nikoPatientDetail.isNew ? 'c-message--orange' : 'c-message--note--primary c-message--note--primary--tab'}`}>
                  {(!nikoPatientDetail.isInsuranceReviewed && selectedStatusAbrv !== "intake-reviewed" && nikoPatientDetail.note) &&
                    <React.Fragment>
                    <div className='c-message__badge'>
                          <i className='u-icon u-icon--size--badge u-icon--info-fill--neg'
                            onMouseEnter={() => { fetchInsuranceChangeHistory(nikoPatientDetail); nikoFacilityOrderUSIntakePreviewViewStore.setShowInsuranceChangeHistory(nikoPatientDetail.id); }}
                            onMouseLeave={() => { nikoFacilityOrderUSIntakePreviewViewStore.setShowInsuranceChangeHistory(null); }}>
                          </i>
                      </div>
                    <div className={`has-input ${nikoPatientDetail.isNew || !nikoPatientDetail.hasHistory ? '' : 'c-message--has-border'} u-flex--default u-flex--gap--1 w--100`} >
                      Note: <p style={{ fontWeight: "normal" }}>{nikoPatientDetail.note}</p>
                      {renderChangeHistory("Note")}
                      {nikoPatientDetail.effectiveDate &&
                        <span className="u-align--h--right type--whitespace--nowrap">Effective Date: {toDate(nikoPatientDetail.effectiveDate)}</span>
                      }
                    </div>
                    </React.Fragment>
                  }
                  {!nikoPatientDetail.isNew &&
                    <React.Fragment>
                      <div className='c-message__badge'>
                          Changes
                          <i className='u-icon u-icon--size--badge u-icon--info-fill--neg'
                            onMouseEnter={() => { fetchInsuranceChangeHistory(nikoPatientDetail); nikoFacilityOrderUSIntakePreviewViewStore.setShowInsuranceChangeHistory(nikoPatientDetail.id); }}
                            onMouseLeave={() => { nikoFacilityOrderUSIntakePreviewViewStore.setShowInsuranceChangeHistory(null); }}>
                          </i>
                      </div>
                      {nikoPatientDetail.primaryActive.insuranceId.current != nikoPatientDetail.primaryActive.insuranceId.initial &&
                        <div className="u-flex--default u-flex--gap--2 c-message--content">
                          <p className="type--sml"><b>Primary Active Changed</b></p>
                          <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.primaryActive.insurance.initial ? nikoPatientDetail.primaryActive.insurance.initial.Name : "Empty"}</b></label>
                          <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                          <p className="type--sml"><b>{nikoPatientDetail.primaryActive.insurance.current ? nikoPatientDetail.primaryActive.insurance.current.name : "Empty"}</b></p>
                          {renderChangeHistory("PrimaryActiveInsuranceId")}
                        </div>
                      }
                      {nikoPatientDetail.primaryActive.insuranceId.current == nikoPatientDetail.primaryActive.insuranceId.initial && nikoPatientDetail.primaryActive.policyNo.current != nikoPatientDetail.primaryActive.policyNo.initial &&
                        <div className="u-flex--default u-flex--gap--2 c-message--content">
                          <p><b>Primary Active Policy Number Changed</b></p>
                          <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.primaryActive.policyNo.initial}</b></label>
                          <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                          <p className="type--sml"><b>{nikoPatientDetail.primaryActive.policyNo.current}</b></p>
                          {renderChangeHistory("PrimaryActivePolicyNo")}
                        </div>
                      }
                      {nikoPatientDetail.primaryInactive.insuranceId.current && nikoPatientDetail.primaryInactive.insuranceId.current != nikoPatientDetail.primaryInactive.insuranceId.initial &&
                        <div className="u-flex--default u-flex--gap--2 c-message--content">
                          <p className="type--sml"><b>Primary Inactive Changed</b></p>
                          <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.primaryInactive.insurance.initial ? nikoPatientDetail.primaryInactive.insurance.initial.Name : "Empty"}</b></label>
                          <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                          <p className="type--sml"><b>{nikoPatientDetail.primaryInactive.insurance.current.name}</b></p>
                          {renderChangeHistory("PrimaryInactiveInsuranceId")}
                        </div>
                      }
                      {nikoPatientDetail.primaryInactive.insuranceId.current && nikoPatientDetail.primaryInactive.insuranceId.current == nikoPatientDetail.primaryInactive.insuranceId.initial && nikoPatientDetail.primaryInactive.policyNo.current != nikoPatientDetail.primaryInactive.policyNo.initial &&
                        <div className="u-flex--default u-flex--gap--2 c-message--content">
                          <p className="type--sml"><b>Primary Inactive Policy Number Changed</b></p>
                          <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.primaryInactive.policyNo.initial}</b></label>
                          <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                          <p className="type--sml"><b>{nikoPatientDetail.primaryInactive.policyNo.current}</b></p>
                          {renderChangeHistory("PrimaryInactivePolicyNo")}
                        </div>
                      }
                      {nikoPatientDetail.secondaryActive.insuranceId.current != nikoPatientDetail.secondaryActive.insuranceId.initial &&
                        <div className="u-flex--default u-flex--gap--2 c-message--content">
                          <p className="type--sml"><b>Secondary Active Changed</b></p>
                          <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.secondaryActive.insurance.initial ? nikoPatientDetail.secondaryActive.insurance.initial.Name : "Empty"}</b></label>
                          <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                          <p className="type--sml"><b>{nikoPatientDetail.secondaryActive.insurance.current ? nikoPatientDetail.secondaryActive.insurance.current.name : "Empty"}</b></p>
                          {renderChangeHistory("SecondaryActiveInsuranceId")}
                        </div>
                      }
                      {nikoPatientDetail.secondaryActive.insuranceId.current == nikoPatientDetail.secondaryActive.insuranceId.initial && nikoPatientDetail.secondaryActive.policyNo.current != nikoPatientDetail.secondaryActive.policyNo.initial &&
                        <div className="u-flex--default u-flex--gap--2 c-message--content">
                          <p className="type--sml"><b>Secondary Active Policy Number Changed</b></p>
                          <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.secondaryActive.policyNo.initial}</b></label>
                          <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                          <p className="type--sml"><b>{nikoPatientDetail.secondaryActive.policyNo.current}</b></p>
                          {renderChangeHistory("SecondaryActivePolicyNo")}
                        </div>
                      }
                      {nikoPatientDetail.secondaryInactive.insuranceId.current && nikoPatientDetail.secondaryInactive.insuranceId.current != nikoPatientDetail.secondaryInactive.insuranceId.initial &&
                        <div className="u-flex--default u-flex--gap--2 c-message--content">
                          <p className="type--sml"><b>Secondary Inactive Changed</b></p>
                          <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.secondaryInactive.insurance.initial ? nikoPatientDetail.secondaryInactive.insurance.initial.Name : "Empty"}</b></label>
                          <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                          <p className="type--sml"><b>{nikoPatientDetail.secondaryInactive.insurance.current.name}</b></p>
                          {renderChangeHistory("SecondaryInactiveInsuranceId")}
                        </div>
                      }
                      {nikoPatientDetail.secondaryInactive.insuranceId.current && nikoPatientDetail.secondaryInactive.insuranceId.current == nikoPatientDetail.secondaryInactive.insuranceId.initial && nikoPatientDetail.secondaryInactive.policyNo.current != nikoPatientDetail.secondaryInactive.policyNo.initial &&
                        <div className="u-flex--default u-flex--gap--2 c-message--content">
                          <p className="type--sml"><b>Secondary Inactive Policy Number Changed</b></p>
                          <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.secondaryInactive.policyNo.initial}</b></label>
                          <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                          <p className="type--sml"><b>{nikoPatientDetail.secondaryInactive.policyNo.current}</b></p>
                          {renderChangeHistory("SecondaryInactivePolicyNo")}
                        </div>
                      }
                      {nikoPatientDetail.eligibilityStatusId != (nikoPatientDetail.initialNikoPatientDetail ? nikoPatientDetail.initialNikoPatientDetail.EligibilityStatusId : null) &&
                        <div className="u-flex--default u-flex--gap--2 c-message--content">
                          <p className="type--sml"><b>Insurance status changed</b></p>
                          <label className="type--sml type--color--opaque"><b>{nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.EligibilityStatus ? nikoPatientDetail.initialNikoPatientDetail.EligibilityStatus.Name : "Empty"}</b></label>
                          <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                          <p className="type--sml"><b>{nikoPatientDetail.eligibilityStatus ? nikoPatientDetail.eligibilityStatus.name : "Empty"}</b></p>
                          {renderChangeHistory("EligibilityStatusId")}
                        </div>
                      }
                      {nikoPatientDetail.patientTemplates.map(pt => {
                        return (!pt.isNew && (pt.isPriorAuthNeeded ? true : false) != (pt.initialPatientTemplate && pt.initialPatientTemplate.IsPriorAuthNeeded ? true : false) &&
                          <div key={pt.id + "-par"} className="u-flex--default u-flex--gap--2 c-message--content">
                            <p className="type--sml"><b>{`${pt.subCategory.name} template ${pt.portalId} PAR changed`}</b></p>
                            <label className="type--sml type--color--opaque"><b>{pt.initialPatientTemplate && pt.initialPatientTemplate.IsPriorAuthNeeded ? "TRUE" : "FALSE"}</b></label>
                            <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
                            <p className="type--sml"><b>{pt.isPriorAuthNeeded ? "TRUE" : "FALSE"}</b></p>
                            {renderChangeHistory("PAR_" + pt.id)}
                          </div>
                        );
                      })
                      }
                    </React.Fragment>
                  }
                </div>
              }
            </div>
          </div>
        </React.Fragment>

        <div className="card--tertiary__body is-niko">
          {
            nikoPatientDetail.patientTemplates.map(patientTemplate => {
              return (
                <PatientTemplateTable
                  key={patientTemplate.id}
                  nikoFacilityOrderUSIntakePreviewViewStore={nikoFacilityOrderUSIntakePreviewViewStore}
                  patientTemplate={patientTemplate}
                  nikoPatientDetail={nikoPatientDetail}
                />
              );
            })
          }
        </div>
      </div>
    </React.Fragment>
  );
});

NikoPatientTemplate.propTypes = {
  nikoFacilityOrderUSIntakePreviewViewStore: PropTypes.object.isRequired,
  nikoPatientDetail: PropTypes.object.isRequired
};

const PatientTemplateTable = observer(({ nikoFacilityOrderUSIntakePreviewViewStore, patientTemplate, nikoPatientDetail }) => {
  const {
    disabledByStatus,
    disabledBySendOrder,
    disabled,
    selectedStatusAbrv,
    inProgressStatusId,
    changeStatusId,
    noChangeStatusId,
    newOrderStatusId,
    dischargeStatusId,
    insertImportActionId,
    deleteImportActionId,
    ostomyItemCategoryId,
    addEmptyItem,
    openPatientTemplateMissingProductNoteModal,
    openPatientTemplateInvoiceNoteModal,
    isDisabledTemplateReview,
    openPatientTemplateNoteModal,
    openPatientTemplateDoNotSupplyModal,
    openClinicalInformationModal,
    openPatientTemplateDiscontinuedModal,
    openPatientTemplateDeleteModal,
    reviewPatientTemplates,//
    updatePatientTemplateNote,//NI
    editItem,
    updateItem,
    openNikoPatientTemplateItemCalculationModal,
    swapPatientTemplateItem,
    setAction,
    updateImportActionId,
    deletePatientTemplateItem,
    clinicalReviewStatus,
    usIntakeStatus,
    saveItemOnProductSelect,
    getFieldHistory,
    trachTubeSubCategoryId,
    isMasterPatient,
    facilityOrder,
    showItemQuantities,
    templateExpanded,
    // disabledPatient,
    // openFacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal,
    // facilityOrderPatient,
    // sendAgoraPo,
    // openFacilityOrderTemplateNewFlowInvoiceNoteModal,
    // openFacilityOrderTemplateDoNotSupplyModal,
    // openFacilityOrderTemplateNewFlowUSIntakeClinicalInformationModal,
    // setTemplateStatus,
    // pageViewStore,
    // facilityOrder,
    // updatePortalNote,
    // productStore,
    // deleteFacilityOrderTemplateItem,
    // setImportAction,
    // setItemToggle
  } = nikoFacilityOrderUSIntakePreviewViewStore;

  //   document.addEventListener('click', function (e) {
  //     const elements = [
  //       document.getElementById(`templateQuantity-${templateExpanded.id}`),
  //       document.getElementById(`orderQuantity-${templateExpanded.id}`),
  //     ];

  //     const clickedOutside = elements
  //       .filter((el) => el !== null)
  //       .every((el) => !el.contains(e.target));

  //     if (clickedOutside) {
  //       templateExpanded.expanded = false;
  //     }
  //   });

  //   const isExpanded = () => {
  //     return isMasterPatient || (facilityOrderTemplate.id === templateExpanded.id && templateExpanded.expanded === true);
  //   }

  //   const tableColSpan = () => {
  //     if (facilityOrderTemplate.isDifferentQty) {
  //       return 6;
  //     }
  //     if (!isExpanded()) {
  //       return 5;
  //     }
  //     else {
  //       return 6;
  //     }
  //   }

  //   const handleDropDownItemsOnClick = async (e, facilityOrderTemplateId) => {
  //     if (e.item.text === "No changes") {
  //       setTemplateStatus("no-change", facilityOrderTemplateId);
  //     }
  //     else if (e.item.text === "Change/Review") {
  //       setTemplateStatus("change", facilityOrderTemplateId);
  //     }
  //     else if (e.item.text === "Discontinued") {
  //       setTemplateStatus("discharge", facilityOrderTemplateId);
  //     }
  //   }
  const TooltipContent = observer(({ initialValue, history, fieldName }) => {
    if (!history || history.fieldName !== fieldName) return null;

    const date = new Date(history.eventDate + "Z");
    const formattedDate = date.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');

    if (fieldName === 'ImportAction') {
      return (<div>
        <div>{history.action} by {history.userName}</div>
        <div style={{ fontSize: '11px', opacity: 0.75 }}>{formattedDate}</div>
      </div>);
    }
    return (<div>
      <div>Previous: {initialValue ? initialValue : 'blank'}</div>
      <div style={{ fontSize: '11px', opacity: 0.75 }}>
        {history ? history.userName + ', ' + formattedDate : '—'}
      </div>
    </div>)
  });

  const productDropdownItemRender = (li, itemProps) => {
    const itemName = itemProps && itemProps.dataItem.description;
    const isPreferredIcon = itemProps && itemProps.dataItem.isPreferred && patientTemplate.itemCategoryId === ostomyItemCategoryId ?
      <i className="u-icon u-icon--xsml u-icon--star-outlined u-mar--right--tny"></i> : null;
    const isBackorderedIcon = itemProps && itemProps.dataItem.backordered ? <i className="u-icon u-icon--sml u-icon--backordered u-mar--left--tny"></i> : null;
    const nonBillableIcon = itemProps && !itemProps.dataItem.billableToMedicare ? <i className="u-icon u-icon--sml u-icon--non-billable u-mar--left--tny"></i> : null;
    const itemChildren = (
      <span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
        <span style={{ flex: "1" }}> {li.props.children} </span>
        <span style={{ fontSize: "12px" }}> {isPreferredIcon} {itemName} {nonBillableIcon} {isBackorderedIcon}</span>
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  }

  const handleItemClick = (e) => {
    e.currentTarget.select();
    showItemQuantities(patientTemplate, true);
  };

  //   const isUnreviewDisabled = nikoPatientDetail.disabled || disabled || disabledSendOrder || !!(facilityOrderStatus && facilityOrderStatus.completedOn) || (facilityOrderTemplate.isClinicalReviewed && (!!facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "clinical-review")));
  const masterPatient = isMasterPatient(nikoPatientDetail);

  const isExpanded = () => {
    return masterPatient || (patientTemplate.id === templateExpanded.id && templateExpanded.expanded === true);
  }

  const tableColSpan = () => {
    if (patientTemplate.isDifferentQty) {
      return 6;
    }
    if (!isExpanded()) {
      return 5;
    }
    else {
      return 6;
    }
  }

  const dropdownRef = React.createRef();
  return (
    <React.Fragment>
      <ReactTooltip positionStrategy="fixed" id={"patientTemplateTooltip" + patientTemplate.id} place="bottom" />
      <ReactTooltip positionStrategy="fixed" id={"patientTemplateTopTooltip" + patientTemplate.id} place="top" />
      {selectedStatusAbrv !== "discharge" &&
        <div className='niko__status__wrapper '>
          {patientTemplate.isNew ?
            <div className={`u-mar--right--status-top  ${disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled ? "is-disabled" : ""}`}>
              <div className="niko__status no-bg yellow">
                <div className="niko__status__holder">
                  <Button className="niko__status__btn" icon="u-icon u-icon--xsml u-icon--box--yellow" onClick={() => { }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}>NEW ORDER</Button>
                </div>
              </div>
            </div>
            :
            patientTemplate.intakeStatusId === inProgressStatusId ?
              <div className="niko__status grey u-mar--right--status-top">
                <div className={`niko__status__holder not-assigned`}>
                  <Button
                    icon="u-icon u-icon--xxsml u-icon--info-fill u-mar--y--sml"
                    className="niko__status__btn"
                    onClick={() => { }}
                  >
                    NOT ASSIGNED
                  </Button>
                </div>
              </div>
              :
              <div className={` u-mar--right--status-top ${disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled ? "is-disabled" : ""}`}>
                <div className={`niko__status ${patientTemplate.intakeStatusId === noChangeStatusId ? "success" : patientTemplate.intakeStatusId === changeStatusId ? "warning" : patientTemplate.intakeStatusId === dischargeStatusId ? "danger" : ""}`}>
                  <div className="niko__status__holder ">
                    <Button
                      // icon="u-icon u-icon--xxsml u-icon--info-fill u-mar--y--sml"
                      className={`niko__status__btn ${patientTemplate.intakeStatusId === noChangeStatusId ? "success" : patientTemplate.intakeStatusId === changeStatusId ? "warning" : patientTemplate.intakeStatusId === dischargeStatusId ? "danger" : ""}`}
                      onClick={() => { }}
                      disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                    >
                      {`${patientTemplate.intakeStatusId === noChangeStatusId ? "NO CHANGES" : patientTemplate.intakeStatusId === changeStatusId ? "CHANGES" : patientTemplate.intakeStatusId === dischargeStatusId ? "DISCONTINUED" : ""}`}
                    </Button>
                  </div>
                </div>
              </div>
          }
        </div>
      }
      <div className={`table--secondary__wrapper u-mar--bottom--med--condition is-niko ${trachTubeSubCategoryId == patientTemplate.subCategoryId && patientTemplate.isDiscontinued && nikoPatientDetail.status == "Active" ? 'is-add-new-disabled' : ''} ${selectedStatusAbrv === "discharge" ? "danger" : patientTemplate.isNew ? "new" : patientTemplate.intakeStatusId === noChangeStatusId ? "success" : patientTemplate.intakeStatusId === changeStatusId ? "warning-triangle" : patientTemplate.intakeStatusId === dischargeStatusId ? "danger" : ""} ${disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled || (patientTemplate.patientTemplateItems && patientTemplate.patientTemplateItems.some(x => !x.productId)) ? 'is-add-new-disabled' : ''}`}>
        {/* <ReactTooltip positionStrategy="fixed" id={"registerTemplateTip" + facilityOrderTemplate.id} place="bottom" /> */}
        <table className="table--secondary w--100">
          <colgroup>
            <col width={400} />
            <col width={150} />
            <col width={70} />
            {(isExpanded() || patientTemplate.isDifferentQty) && patientTemplate.patientTemplateItems.length > 0 && <col width={70} />}
            <col />
            <col width={70} />
          </colgroup>
          <thead>
            <tr>
              <th colSpan={tableColSpan()} className="btn--group__wrapper">
                <div className="u-flex--space-between">
                  <label>{patientTemplate.subCategory.name.toUpperCase()}</label>
                  {patientTemplate.isEligibleToSend != null && nikoPatientDetail.status == "Active" && !patientTemplate.isDiscontinued && !patientTemplate.isUserDns && !patientTemplate.isSystemDns && patientTemplate.patientTemplateItems.some(x => x.productId && x.actionId != deleteImportActionId && x.salesOrderQuantity > 0) &&
                    <div className="u-mar--left--xsml u-mar--bottom--tny" data-tooltip-content={!patientTemplate.isEligibleToSend && patientTemplate.nextSendDate ? `Next Send Date: ${toDate(patientTemplate.nextSendDate)}` : null} data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id}>
                      {patientTemplate.isEligibleToSend ? <i className="u-icon u-icon--med u-icon--calendar-yes--dark" /> : <i className="u-icon u-icon--med u-icon--calendar-x--dark" />}
                    </div>
                  }
                  {patientTemplate.isDiscontinued &&
                    <div>
                      <div className="u-mar--left--xsml btn--disc__wrapper">
                        Discontinued
                        <Button className="btn btn--disc" onClick={() => { openPatientTemplateDiscontinuedModal(patientTemplate) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}>
                          <i className="u-icon u-icon--xxsml u-icon--close--neg"></i>
                        </Button>
                      </div>
                    </div>
                  }
                  {patientTemplate.isUserDns &&
                    <div>
                      <div className="u-mar--left--xsml btn--disc__wrapper is-fr">
                        Do not supply - FR
                        <Button className="btn btn--disc" onClick={() => { openPatientTemplateDoNotSupplyModal(patientTemplate) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}>
                          <i className="u-icon u-icon--xxsml u-icon--close--neg"></i>
                        </Button>
                      </div>
                    </div>
                  }
                  {patientTemplate.isSystemDns &&
                    <div>
                      <div className="u-mar--left--xsml btn--disc__wrapper is-fr">
                        Do not supply
                      </div>
                    </div>
                  }
                  {
                    patientTemplate.missingProductNote &&
                    <React.Fragment>
                      <Button className="btn btn--status--red u-mar--left--xsml" icon="u-icon u-icon--med-lrg u-icon--missing-product" onClick={() => { openPatientTemplateMissingProductNoteModal(patientTemplate) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} />
                    </React.Fragment>
                  }
                  {
                    <div className="card--tertiary__header__actions u-align--h--right">
                      <div className="btn--group">
                        {nikoPatientDetail.eligibilityStatus && nikoPatientDetail.eligibilityStatus.name == "Eligible" &&
                          <React.Fragment>
                            <div className="status--sqare__wrapper">
                              <BaasicButton
                                type='button'
                                className="btn btn--base-plus btn--light btn--uppercase is-nonclickable"
                                label={(patientTemplate.clinicalStatus && patientTemplate.clinicalStatus.name) || 'Unselected'}
                                disabled={!patientTemplate.clinicalStatusId}
                              />
                            </div>
                            <div className="btn--group__divider"></div>
                          </React.Fragment>
                        }
                        {isMasterPatient(nikoPatientDetail) && facilityOrder && facilityOrder.facility && facilityOrder.facility.sendAgoraPo === false &&
                          <React.Fragment>
                            <ReactTooltip positionStrategy="fixed" id={"patientTemplateInvoiceNoteTooltip" + patientTemplate.id} place="bottom" effect="solid" />
                            <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-invoice-note" onClick={() => { openPatientTemplateInvoiceNoteModal(patientTemplate) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Invoice Note" data-tooltip-id={"patientTemplateInvoiceNoteTooltip" + patientTemplate.id} />
                          </React.Fragment>
                        }
                        {selectedStatusAbrv === "intake-reviewed" && patientTemplate.note &&
                          <Button className="btn no-hover" icon={"u-icon u-icon--med-lrg u-icon--danger-triangle--primary"} onClick={() => { openPatientTemplateNoteModal(patientTemplate) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled || !patientTemplate.note} data-tooltip-content="View Note" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />
                        }
                        {!patientTemplate.missingProductNote &&
                          <React.Fragment>
                            <ReactTooltip positionStrategy="fixed" id={"patientTemplateMissingProductNoteTooltip" + patientTemplate.id} place="bottom" />
                            <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-question-note" onClick={() => { openPatientTemplateMissingProductNoteModal(patientTemplate) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Missing Product Note" data-tooltip-id={"patientTemplateMissingProductNoteTooltip" + patientTemplate.id} />
                          </React.Fragment>
                        }
                        {!patientTemplate.isUserDns &&
                          <div className="btn--group status--sqare__wrapper">
                            <ReactTooltip positionStrategy="fixed" id={"patientTemplateDoNotSupplyTooltip" + patientTemplate.id} place="bottom" />
                            {/* data-tooltip-content={`Mark As Do Not Supply`} data-tooltip-id={(disabled || disabledSendOrder || nikoPatientDetail.disabled || (facilityOrderTemplate.isDoNotSupply && facilityOrderTemplate.inactiveReasonId === 16) || facilityOrderTemplate.inactiveReasonId === 15) ? `registerTemplateTip${facilityOrderTemplate.id}` : ""}> */}
                            <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--do-not-supply" onClick={() => { openPatientTemplateDoNotSupplyModal(patientTemplate) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content={`Mark As Do Not Supply`} data-tooltip-id={"patientTemplateDoNotSupplyTooltip" + patientTemplate.id} />
                          </div>
                        }
                        <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--clinical-info" onClick={() => { openClinicalInformationModal(nikoPatientDetail, patientTemplate) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Clinical Info" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />
                        {!patientTemplate.isNew && !patientTemplate.isDiscontinued && <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--danger--primary" onClick={() => openPatientTemplateDiscontinuedModal(patientTemplate)} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Discontinued" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />}
                        {patientTemplate.isNew && <Button className="btn no-hover" icon="u-icon u-icon--delete--brand u-icon--med-lrg" onClick={() => openPatientTemplateDeleteModal(nikoPatientDetail, patientTemplate)} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} data-tooltip-content="Delete Template" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />}
                        <div className="btn--group__divider"></div>
                      </div>
                      {
                        patientTemplate.isUsIntakeReviewed ?
                          <div className="status--sqare__wrapper" data-tooltip-content={patientTemplate.isClinicalReviewed && (disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled || !!clinicalReviewStatus || !!(usIntakeStatus && usIntakeStatus.completedOn)) ? "Template is clinically reviewed" : "Unreview"} data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id}>
                            <Button className="btn btn--icon btn--icon--lrg btn--primary" icon="u-icon u-icon--med u-icon--unreview" onClick={() => { reviewPatientTemplates(nikoPatientDetail, patientTemplate.id, false) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled || (patientTemplate.isClinicalReviewed && !!clinicalReviewStatus) || !!(usIntakeStatus && usIntakeStatus.completedOn)} />
                          </div>
                          :
                          selectedStatusAbrv === "discharge" ?
                            <Button className="btn btn--icon btn--icon--lrg btn--primary" icon="u-icon u-icon--med u-icon--check-list" disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled} onClick={() => { reviewPatientTemplates(nikoPatientDetail, patientTemplate.id, true) }} data-tooltip-content="Review" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />
                            :
                            <div data-tooltip-content={nikoPatientDetail.eligibilityStatusId ? null : "Insurance changes must be reviewed"} data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id}>
                              <Button className="btn btn--icon btn--icon--lrg btn--primary" icon="u-icon u-icon--med u-icon--check-list" disabled={(selectedStatusAbrv !== "discharge" && isDisabledTemplateReview(nikoPatientDetail)) || disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled || !nikoPatientDetail.eligibilityStatusId} onClick={() => { reviewPatientTemplates(nikoPatientDetail, patientTemplate.id, true) }} data-tooltip-content="Review" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />
                            </div>
                      }
                    </div>
                  }
                </div>
                {patientTemplate.note && selectedStatusAbrv !== "intake-reviewed" &&
                  <div className={`u-mar--top--sml u-mar--bottom--xsml c-message has-input u-flex--default w--100 c-message--note${patientTemplate.intakeStatusId === dischargeStatusId ? "--discontinued" : patientTemplate.intakeStatusId === noChangeStatusId ? "--green" : patientTemplate.intakeStatusId === changeStatusId ? "--orange" : patientTemplate.intakeStatusId === newOrderStatusId || patientTemplate.isNew ? "--primary" : ""} u-mar--top--tny`}>
                    {/* ${(isExpanded() || facilityOrderTemplate.isDifferentQty) && facilityOrderTemplate.facilityOrderTemplateItems.length > 0 ? 'u-mar--bottom--med' : ''}`}> */}
                    <i className="u-icon u-icon--sml u-icon--danger-triangle" />
                    <input
                      className="input input--sml input--message u-flex--grow--1 type--sml"
                      onClick={(e) => e.target.select()}
                      onChange={(e) => { patientTemplate.tempNote = e.target.value }}
                      onBlur={async () => { await updatePatientTemplateNote(patientTemplate) }}
                      value={patientTemplate.tempNote}
                      disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                    />
                  </div>
                }
              </th>
            </tr>
            <tr>
              <th className="table__label--sml"></th>
              <th className="table__label--sml"></th>
              {(isExpanded() || patientTemplate.isDifferentQty) && patientTemplate.patientTemplateItems.length > 0 && <th className="table__label--sml"><span className="table__label--inner">TEMP QTY</span></th>}
              {(isExpanded() || patientTemplate.isDifferentQty) && patientTemplate.patientTemplateItems.length > 0 && <th className="table__label--sml"><span className="table__label--inner">SO QTY</span></th>}
            </tr>
          </thead>
          <tbody style={(patientTemplate.isSystemDns || patientTemplate.isUserDns) ? { opacity: "0.5" } : {}}>
            {patientTemplate.patientTemplateItems.map((item) => {
              var isFormula = item.product && (item.product.itemTypeId || (item.product.procedureCode_ && item.product.procedureCode_.abrv === "B4155"));
              if (!item.product && item.toggle) {
                setTimeout(() => {
                  if (dropdownRef.current) {
                    // v14 dropped the inner .k-dropdown-wrap — the DropDownList root element is the clickable toggle
                    const toggle = dropdownRef.current.element;
                    if (toggle) {
                      item.toggle = false;
                      toggle.click();
                    }
                  }
                }, 0);
              }
              return (
                <tr key={item.id} className={`${(!patientTemplate.isNew && item.actionId === insertImportActionId && !nikoPatientDetail.isNew) ? "new-row" : (item.actionId === deleteImportActionId ? "deleted-row" : "")} ${item.product ? "" : "is-focused"}`}>
                  <td className="table-col-input is-flex">
                    <ReactTooltip positionStrategy="fixed" id={"registerTipImportAction" + item.id} place="top" delayShow={650} render={() => <TooltipContent initialValue={null} history={item.history} fieldName={"ImportAction"} />} />
                    <ItemActionTriangle item={item} insertActionId={insertImportActionId} deleteActionId={deleteImportActionId} tooltipId={"registerTipImportAction" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'ImportAction', null)} />
                    {
                      item.product ?
                        <React.Fragment>{item.product.description} <span className="table__icons-wrapper"> {!item.product.billableToMedicare && <i className="u-icon u-icon--sml u-icon--non-billable"></i>} {(item.isBackordered != null ? item.isBackordered : item.product.backordered) && <i className="u-icon u-icon--med-lrg u-icon--backordered"></i>}</span></React.Fragment>
                        :
                        <BaasicDropdown
                          placeholder="Select item name..."
                          store={patientTemplate.productStore}
                          value={item.product}
                          className="input--table"
                          itemRender={productDropdownItemRender}
                          onChange={(e) => { saveItemOnProductSelect(patientTemplate, item, e.target.value) }}
                          disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                          customRef={dropdownRef}
                        />
                    }
                  </td>
                  <td>
                    {item.product && item.product.itemId}
                  </td>
                  <td className="table-col-input text-align-left has-input" id={"templateQuantity-" + patientTemplate.id}>
                    <ReactTooltip positionStrategy="fixed" id={"registerTipQuantity" + item.id} place="top" delayShow={650} render={() => <TooltipContent initialValue={item.initialPatientTemplateItem && item.initialPatientTemplateItem.Quantity} history={item.history} fieldName={"Quantity"} />} />
                    {!patientTemplate.inNew && !nikoPatientDetail.isNew && item.initialPatientTemplateItem && item.initialPatientTemplateItem.Quantity != item.savedQuantity && item.actionId !== insertImportActionId &&
                      <div className="table-col-input__notif opacity-50" data-tooltip-id={"registerTipQuantity" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'Quantity', item.savedQuantity)} data-tooltip-content="" ></div>}
                    {item.product &&
                      <input
                        className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                        onClick={(e) => handleItemClick(e)}
                        onKeyDown={handleKeyDown}
                        onPaste={handlePaste}
                        onChange={(e) => { editItem(item, 'quantity', parseInt(e.target.value)) }}
                        onBlur={() => { updateItem(item, patientTemplate) }}
                        value={item.quantity || item.quantity === 0 ? item.quantity : undefined}
                        type="number"
                        min="0"
                        disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled || masterPatient}
                      />
                    }
                    {(item.sendSeparatelyQuantity | 0) > 0 && <i className="u-icon u-icon--ss u-icon--sml table__icon--ss" data-tooltip-id={"patientTemplateTopTooltip" + patientTemplate.id} data-tooltip-content={item.sendSeparatelyQuantity} />}
                  </td>
                  {(isExpanded() || patientTemplate.isDifferentQty) &&
                  <td className="table-col-input text-align-left has-input" id={"orderQuantity-" + patientTemplate.id}>
                    <ReactTooltip positionStrategy="fixed" id={"registerTipSalesOrderQuantity" + item.id} place="top" delayShow={650} render={() => <TooltipContent initialValue={item.initialPatientTemplateItem && item.initialPatientTemplateItem.SalesOrderQuantity} history={item.history} fieldName={"SalesOrderQuantity"} />} />
                    {!patientTemplate.inNew && !nikoPatientDetail.isNew && item.initialPatientTemplateItem && item.initialPatientTemplateItem.SalesOrderQuantity != item.savedSalesOrderQuantity && item.actionId !== insertImportActionId &&
                      <div className="table-col-input__notif opacity-50" data-tooltip-id={"registerTipSalesOrderQuantity" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'SalesOrderQuantity', item.savedSalesOrderQuantity)} data-tooltip-content="" ></div>}
                    {item.product &&
                      <input
                        className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                        onClick={(e) => handleItemClick(e)}
                        onKeyDown={handleKeyDown}
                        onPaste={handlePaste}
                        onChange={async (e) => { editItem(item, 'salesOrderQuantity', parseInt(e.target.value)) }}
                        onBlur={() => { updateItem(item, patientTemplate) }}
                        value={item.salesOrderQuantity}
                        type="number"
                        min="0"
                        disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                      />
                    }
                  </td>}
                  <td className="table-col-input">
                    {/* <ReactTooltip positionStrategy="fixed" id={"registerTipItemChangedNote" + item.id} place="top" /> */}
                    <ReactTooltip positionStrategy="fixed" id={"registerTipNote" + item.id} place="top" delayShow={650} render={() => <TooltipContent initialValue={item.initialPatientTemplateItem && item.initialPatientTemplateItem.Note} history={item.history} fieldName={"Note"} />} />
                    {!patientTemplate.isNew && !nikoPatientDetail.isNew && item.initialPatientTemplateItem && item.initialPatientTemplateItem.Note != item.savedNote && item.actionId !== insertImportActionId &&
                      <div className="table-col-input__notif opacity-50" data-tooltip-id={"registerTipNote" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'Note', item.savedNote)} data-tooltip-content="" ></div>}
                    {isFormula && !masterPatient ?
                      <input
                        className="input--table input--inherit-color no-arrows input--text-align--left w--100 u-mar--left--tny"
                        onClick={() => openNikoPatientTemplateItemCalculationModal(item, patientTemplate)}
                        value={item.note}
                        readOnly={true}
                        disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                      />
                      :
                      <input
                        className="input--table input--inherit-color no-arrows input--text-align--left w--100 u-mar--left--tny"
                        onClick={(e) => e.target.select()}
                        onChange={(e) => { editItem(item, 'note', e.target.value) }}
                        onBlur={() => { updateItem(item, patientTemplate) }}
                        value={item.note}
                        disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled || !item.product}
                        readOnly={false}
                      />
                    }
                  </td>
                  <td className="type--center is-hidden">
                    <div className="table__icons">
                      {item.actionId !== insertImportActionId && !(trachTubeSubCategoryId == patientTemplate.subCategoryId && patientTemplate.isDiscontinued && nikoPatientDetail.status == "Active") &&
                        <Button
                          disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                          className="btn btn--icon"
                          icon="u-icon u-icon--update-table u-icon--sml"
                          label="Change"
                          title={"Swap"}
                          onClick={() => swapPatientTemplateItem(item, patientTemplate, nikoPatientDetail)}
                        ></Button>
                      }
                      {item.actionId === deleteImportActionId ?
                        <Button
                          className="btn btn--icon is-delete"
                          icon="u-icon u-icon--sml u-icon--undo--table"
                          label="Undelete"
                          onClick={() => setAction(item, updateImportActionId, patientTemplate)}
                          disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                          title={"Undo"}
                        ></Button>
                        :
                        <Button
                          className="btn btn--icon is-delete"
                          icon={`u-icon u-icon--sml ${!item.product ? "u-icon--close--table" : "u-icon--delete--primary"}`}
                          onClick={() => { deletePatientTemplateItem(item, patientTemplate, nikoPatientDetail) }}
                          disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}
                          title={!item.product ? "Cancel" : "Delete"}
                        ></Button>
                      }
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {patientTemplate.patientTemplateItems && !patientTemplate.patientTemplateItems.some(x => !x.productId) &&
          <button className={`table--secondary__add-button${(disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled) ? ' is-disabled' : ''}`} onClick={() => { addEmptyItem(patientTemplate) }} disabled={disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled}>
            <span></span>
          </button>
        }
      </div>
    </React.Fragment>
  );
});

PatientTemplateTable.propTypes = {
  nikoFacilityOrderUSIntakePreviewViewStore: PropTypes.object.isRequired,
  patientTemplate: PropTypes.object.isRequired,
  nikoPatientDetail: PropTypes.object.isRequired
};

export default defaultTemplate(NikoFacilityOrderUSIntakePreviewTemplate);
